import { render, staticRenderFns } from "./apprentice.vue?vue&type=template&id=6b3e8d52&scoped=true&"
import script from "./apprentice.vue?vue&type=script&lang=js&"
export * from "./apprentice.vue?vue&type=script&lang=js&"
import style0 from "./apprentice.vue?vue&type=style&index=0&id=6b3e8d52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e8d52",
  null
  
)

export default component.exports